import React from 'react'
import Svg from '../Svg'
import { logoSvg } from '../../config/sites/assets'

const Logo = ({ ...props }) => {
  return <Svg src={logoSvg.toString()} {...props} />
}

export default Logo
